export default "__VITE_ASSET__Bf1kH6c7__"